var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 11",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "colorize",
    transform: "translate(-1 -3)",
    d: "M12.103 6.833a1.013 1.013 0 0 1-1.026-1c0-.552.459-1 1.026-1 .566 0 1.025.448 1.025 1 0 .553-.459 1-1.025 1zm1.025 5H2.872v-3.5L4.046 7.19a1.263 1.263 0 0 1 1.755 0l1.672 1.63.527.514.593.579a.562.562 0 0 0 .782-.003.531.531 0 0 0 0-.765l-.59-.575.389-.38a1.263 1.263 0 0 1 1.755 0l2.2 2.144v1.5zm.513-8.5H2.359c-.567 0-1.026.448-1.026 1v8c0 .553.46 1 1.026 1h11.282c.567 0 1.026-.447 1.026-1v-8c0-.552-.46-1-1.026-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.85f081592dec51ca7cb6a951dc47fe09.svg";
export { ForwardRef as ReactComponent };